<template>
  <div class="relative -mt-4 pt-4 md:-mt-8 md:pt-8">
    <LayoutFacetedSearch>
      <template #summary>
        <div /><!-- prevent layout jump -->
        <div class="flex gap-2.5 items-center shrink-0 motion-safe:animate-pulse">
          <label
            class="font-bold"
            for="placeholder-sort-by"
          >Sort By:</label>
          <div class="ais-SortBy">
            <select
              id="placeholder-sort-by"
              class="ais-SortBy-select min-w-[200px]"
              disabled
            >
              <option>Most Recent</option>
            </select>
          </div>
        </div>
      </template>
      <template #filters>
        <div class="mb-5 motion-safe:animate-pulse">
          <label
            class="sr-only"
            for="placeholder-search-box"
          >Keyword search</label>
          <input
            id="placeholder-search-box"
            type="search"
            disabled
            placeholder="Search..."
            class="ais-SearchBox-input"
          >
        </div>
        <div class="lg:hidden flex justify-between w-full text-sm font-semibold capitalize motion-safe:animate-pulse">
          <span>Filters</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 11"
            aria-hidden="true"
            class="w-5 shrink-0"
          ><path
            fill="currentColor"
            d="m9 10.547.86-.899 6.25-6.25.898-.898L15.25.742l-.898.899L9 6.992 3.61 1.641 2.75.742.953 2.5l.899.898 6.25 6.25.898.899Z"
          /></svg>
        </div>
        <div
          v-for="n in 4"
          :key="n"
          class="hidden lg:flex flex-col gap-2.5 mt-4 motion-safe:animate-pulse"
        >
          <div class="h-5 bg-gray-300 max-w-xs w-4/5" />
          <div class="h-5 bg-gray-200 w-2/3" />
          <div class="h-5 bg-gray-200 w-3/4" />
          <div class="h-5 bg-gray-200 w-2/3" />
          <div class="h-5 bg-gray-200 w-3/4" />
        </div>
      </template>
      <template #results>
        <div class="flex flex-col gap-y-16">
          <div class="grid grid-cols-1 gap-y-9 gap-x-8 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-12">
            <PlaceholderHit
              v-for="n in 8"
              :key="n"
            />
          </div>
        </div>
      </template>
    </LayoutFacetedSearch>
  </div>
</template>

<script setup lang="ts">
import LayoutFacetedSearch from '~/components/search/layouts/LayoutFacetedSearch.vue'
import PlaceholderHit from '../hits/PlaceholderHit.vue'
</script>
